import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiPlayCircle } from 'react-icons/fi'
import toast from 'react-hot-toast'
import api from '../utils/api'
import { useAuth } from '../App'

export default function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(true)
  const [loading, setLoading] = useState(false)
  const [surum, setSurum] = useState('')
  const [demoLoading, setDemoLoading] = useState(false)
  const navigate = useNavigate()
  const { login } = useAuth()

  // Kurulu surum (SURUM.json) - sabit yazi degil, sunucudan gelir
  useEffect(() => {
    api.get('/surum').then(({ data }) => setSurum(data.kurulu_surum || '')).catch(() => {})
  }, [])

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const form = new URLSearchParams()
      form.append('username', username)
      form.append('password', password)
      if (rememberMe) form.append('scope', 'remember_me')
      const { data } = await api.post('/auth/login', form, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
      login(data.access_token, data.user)
      toast.success('Hoş geldiniz!')
      navigate('/', { replace: true })
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Giriş başarısız')
    } finally {
      setLoading(false)
    }
  }

  // Demo kapisi — kampanyadan gelen ziyaretci kullanici adi/sifre olmadan girsin.
  // Sifre pakette yok: token'i sunucu uretiyor (POST /auth/demo). Demo hesabi sunucu
  // tarafinda kilitli, yalnizca anonim demo verisini gorur.
  const handleDemo = async () => {
    setDemoLoading(true)
    try {
      const { data } = await api.post('/auth/demo')
      login(data.access_token, data.user)
      toast.success('Demo turuna hoş geldiniz — veriler örnektir')
      navigate('/', { replace: true })
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Demo şu an açılamadı')
    } finally {
      setDemoLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-sidebar flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo/qr-analiz.png" alt="QR Analiz" className="h-20 mx-auto mb-3 drop-shadow-lg" onError={(e) => { e.target.style.display='none' }} />
          <p className="text-primary-200 text-sm">Veri Analiz ve Raporlama Platformu</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white rounded-xl shadow-2xl p-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Giriş Yap</h2>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Kullanıcı Adı</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
              placeholder="admin"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
              placeholder="••••••"
              required
            />
          </div>

          <label className="flex items-center gap-2 mb-6 cursor-pointer select-none">
            <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)}
              className="w-4 h-4 text-primary-600 rounded border-gray-300 focus:ring-primary-500" />
            <span className="text-sm text-gray-700">Beni hatırla (30 gün)</span>
          </label>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary-600 hover:bg-primary-700 text-white py-2.5 rounded-lg font-medium transition-colors disabled:opacity-50"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>

          <div className="flex items-center gap-3 my-5">
            <span className="h-px flex-1 bg-gray-200" />
            <span className="text-xs text-gray-400">veya</span>
            <span className="h-px flex-1 bg-gray-200" />
          </div>

          <button
            type="button"
            onClick={handleDemo}
            disabled={demoLoading}
            className="w-full flex items-center justify-center gap-2 border-2 border-primary-600 text-primary-700 hover:bg-primary-50 py-2.5 rounded-lg font-medium transition-colors disabled:opacity-50"
          >
            <FiPlayCircle className="w-5 h-5" />
            {demoLoading ? 'Demo açılıyor...' : "Demo'yu İncele"}
          </button>
          <p className="text-center text-xs text-gray-500 mt-2">
            Kayıt gerekmez · Örnek verilerle hazır panolar
          </p>
        </form>

        {surum && (
          <p className="text-center text-primary-300/70 text-xs mt-5 select-none">
            QR Analiz · s{surum}
          </p>
        )}
      </div>
    </div>
  )
}
